import Vue from 'vue';
import JwtService from '@/services/jwt.service';

import {setUserModules} from '@/models/chart';

export default {
  mSetError(state, error) {
    state.errors = error;
  },
  mSetAuth(state, user) {
    state.isAuthenticated = true;
    state.user = setUserModules(user);
    state.errors = {};
    JwtService.saveUser(state.user);
    JwtService.saveToken(state.user.token);
  },
  mPurgeAuth(state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
    JwtService.destroyUser();
  }
}
